export const environment = {
  production: false,
  host: 'https://backend.beta-ifc.coordinador.cl',
  host_cognito: 'https://qa-auth.coordinador.cl',
  client_id: '572204mkl0j5dk2qhagh3h523b',
  response_type: 'token',
  redirect_uri: 'https://web.beta-ifc.coordinador.cl/publico/coordinador/sigin',
  redirect_uri_logout: 'https://web.beta-ifc.coordinador.cl/publico/coordinador/logout',
  site_key: '6LeZIqYUAAAAAHWzpTzRQVDmNwzh2xOsTKgtiM4o'
};
